let edsApiInstance = null
export function installEdsApi(ref) {
  if (edsApiInstance === null) {
    edsApiInstance = new EdsApi(ref)
  }
}

export function getEdsApiInstance() {
  return edsApiInstance
}

class EdsApi {
  #ref = null
  constructor(ref) {
    this.#ref = ref
  }

  /**
   * Подписать файл
   * @param file объект вида { fileUrl: "https://...." }
   * @returns {Promise<*>}
   */
  async signFile(file) {
    return await this.#ref.signFile(file)
  }

  /**
   * Подписать строку
   * @param data String
   * @returns {Promise<*>}
   */
  async signData(data) {
    return await this.#ref.signFile(data)
  }
}